// Models
import { FormFieldSchema } from 'app/shared/models/form';
import { U21FormFieldTypes } from 'app/shared/u21-ui/components';

// Utils
import { required } from 'app/shared/utils/validation';

// Constants
import { FUNDS_TYPE_OPTIONS } from 'app/modules/goAML/schemas/catalogues/fundsType';
import { COUNTRY_CODE_OPTIONS } from 'app/modules/goAML/schemas/catalogues/countryCode';
import { FOREIGN_CURRENCY_SCHEMA } from 'app/modules/goAML/schemas/foreignCurrencySchema';

export const TO_FUNDS_CODE: FormFieldSchema<string> = {
  label: 'Funds type',
  name: 'to_funds_code',
  type: U21FormFieldTypes.SELECT,
  required: true,
  validate: required('Funds type is required.'),
  fieldProps: {
    options: FUNDS_TYPE_OPTIONS,
  },
  default: FUNDS_TYPE_OPTIONS[0].value,
};

export const TO_FUNDS_COMMENT: FormFieldSchema<string> = {
  label: 'Funds comment',
  name: 'to_funds_comment',
  type: U21FormFieldTypes.TEXT,
};

export const TO_COUNTRY_CODE = {
  label: 'To country',
  name: 'to_country',
  type: U21FormFieldTypes.SELECT,
  required: true,
  validate: required('Country is required.'),
  fieldProps: {
    options: COUNTRY_CODE_OPTIONS,
  },
  default: 'US',
};

export const T_TO_RAW_INPUTS = [
  TO_FUNDS_CODE,
  TO_FUNDS_COMMENT,
  TO_COUNTRY_CODE,
  // TODO add To Foreign Currency logic
];

// For transactions.ts

export const BASE_SCHEMA = [
  ...T_TO_RAW_INPUTS,
  ...FOREIGN_CURRENCY_SCHEMA.map((field) => ({
    ...field,
    name: `to_foreign_currency.${field.name}`,
  })),
];
